import React from 'react';
import { Body, Box, Icon } from '@hover/blueprint';
import { iPhone } from '@hover/icons';

const CallUsNavbarCta = () => (
  <Box alignItems="center">
    <Box p={1} bgColor="primary.100" borderRadius="50%" mr={2}>
      <Icon icon={iPhone} size="medium" color="primary.900" />
    </Box>
    <Box flexDir="column">
      <Body
        size={200}
        isBold
        letterSpacing="0.15em"
        textTransform="uppercase"
        mb={2}
      >
        Want to talk now? Call us
      </Body>
      <Body size={600} fontWeight={600} color="primary">
        <a href="tel:+18449505074">(844) 950-5074</a>
      </Body>
    </Box>
  </Box>
);

export default CallUsNavbarCta;
